import React from "react";
import { Handle, Position } from "@xyflow/react";
import useHandleConnected from "../nodes/useHandleConnected";

const FALLBACK_ROW_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 8px",
  borderRadius: 6,
  fontSize: 10,
  fontWeight: 600,
  color: "#fff",
  background: "#dc2626",
  border: "1px solid #fca5a5",
  position: "relative",
  marginTop: 4,
};

const LABEL_STYLE = {
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: "right",
};

/**
 * Handles de saída timeout / opção inválida nos blocos de interação.
 */
export default function InteractionFallbackHandles({
  nodeId,
  isConnectable,
  showTimeout = true,
  showInvalid = true,
}) {
  const getHandleClass = useHandleConnected(nodeId);

  if (!showTimeout && !showInvalid) return null;

  return (
    <div style={{ marginTop: 8, borderTop: "1px dashed #e5e7eb", paddingTop: 6 }}>
      {showTimeout && (
      <div style={{ ...FALLBACK_ROW_STYLE }}>
        <span style={LABEL_STYLE}>Sem resposta (timeout)</span>
        <Handle
          type="source"
          position={Position.Right}
          id="timeout"
          className={getHandleClass("source", "timeout")}
          style={{
            position: "absolute",
            top: "50%",
            right: -21,
            transform: "translateY(-50%)",
            cursor: "crosshair",
          }}
          isConnectable={isConnectable}
        />
      </div>
      )}
      {showInvalid && (
      <div style={{ ...FALLBACK_ROW_STYLE, background: "#b91c1c" }}>
        <span style={LABEL_STYLE}>Opção inválida</span>
        <Handle
          type="source"
          position={Position.Right}
          id="invalid"
          className={getHandleClass("source", "invalid")}
          style={{
            position: "absolute",
            top: "50%",
            right: -21,
            transform: "translateY(-50%)",
            cursor: "crosshair",
          }}
          isConnectable={isConnectable}
        />
      </div>
      )}
    </div>
  );
}
